import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getAllPaymentModeByBrandId, getViewPaymentMode } from "../../../services/paymentMode/paymentMode";

const PaymentModeList = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [paymentModeList, setPaymentModeList] = useState([])
  const [paymentModeL1, setPaymentModeL1] = useState([]);
  const [paymentModeL2, setPaymentModeL2] = useState([]);
  const [paymentModeL3, setPaymentModeL3] = useState([]);


  const fetchPaymentMode = (brandId) => {
    setLoading(true)
    getAllPaymentModeByBrandId(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setPaymentModeList(Res);
          setPaymentModeL1(Res?.paymentModeList?.Location1);
          setPaymentModeL2(Res?.paymentModeList?.Location2);
          setPaymentModeL3(Res?.paymentModeList?.Location3);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };



  useEffect(() => {
    fetchPaymentMode(brandId);
  }, []);


  const renderCardItem = (data) => {
     
      return (
        <div>
          <div className="px-3 py-1 flex justify-content-between">
            <p className="text-lg font-normal text-black-700 mt-3">Payment Mode</p>

            <div
              className="mr-4 mt-2"
              onClick={() =>
                navigate("/PaymentModeCreate", {
                  state: {
                    item: paymentModeList,
                  },
                })
              }
            >
              <i
                className="pi pi-pencil"
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#2B70D7",
                }}
              ></i>
            </div>
          </div>
          <div className="flex-1">
            {data.length > 0 ? (
              <div className="grid grid-cols-1 gap-4 mx-4 my-3">
                {data.map((item, index) => (
                  <div
                    key={index}
                    className="rounded-md p-3 shadow"
                    style={{
                      backgroundColor:
                        "#71d0f2ff"
                    }}
                  >
                    <p className="text-base font-semibold capitalize text-gray-800">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="px-3 py-2 text-gray-500 italic">
                No Mode available
              </div>
            )}
          </div>
        </div>
      );
  };

  const renderCardItem2 = (data, type) => {
    return (
      <div>
        <div className="px-3 py-1 flex justify-content-between">
          <p className="text-lg font-normal text-black-700 mt-3">
            {type}:
          </p>
        </div>
        <div className="flex-1">
          {data.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 mx-4 my-3">
              {data.map((item, index) => (
                <div
                  key={index}
                  className="rounded-md p-3 shadow"
                  style={{
                    backgroundColor:
                      "#71d0f2ff"
                  }}
                >
                  <p className="text-base font-semibold capitalize text-gray-800">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="px-3 py-2 text-gray-500 italic">
              No Mode available
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Payment Mode
              </p>
            </div>
          </div>

          {(paymentModeList?.paymentModes === null || paymentModeList?.paymentModes?.length === 0) && (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() =>
                navigate("/PaymentModeCreate", {
                  state: {
                    item: null,
                  },
                })
              }
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : paymentModeList?.paymentModes?.length > 0 ? (
          <div>
              <div>{renderCardItem(paymentModeList?.paymentModes)}</div>
              <div>{renderCardItem2(paymentModeL1, "Orders")}</div>
              <div>{renderCardItem2(paymentModeL2, "Subscription")}</div>
              <div>{renderCardItem2(paymentModeL3, "Rider")}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Time Slot Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PaymentModeList;
